import { HttpInterceptorFn } from '@angular/common/http';
import { of, throwError, timer } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerService } from '../services/spinner/spinner.service';
import { ToastService } from '../services/toast/toast.service';
import { AlertService } from '../services/alert/alert.service';
import { OAuthService } from 'angular-oauth2-oidc';

export const retryCount = 1;
export const retryWaitMilliSeconds = 1000;

export const ErrorInterceptor: HttpInterceptorFn = (request, next) => {
  const translateService = inject(TranslateService);
  const spinnerService = inject(SpinnerService);
  const toastService = inject(ToastService);
  const alertService = inject(AlertService);
  const oauthService = inject(OAuthService);

  return next(request).pipe(
    retry({
      count: retryCount,
      delay: (error, retryAttempt) => {
        if (
          error.status === 0 ||
          (error.status === 400 && !error.error)
        ) {
          return timer(retryWaitMilliSeconds);
        }
        return throwError(() => error);
      }
    }),
    catchError((err) => {
      spinnerService.hide();
      if (err.status === 304) return of(err);

      if ([401, 403].includes(err.status)) {
        alertService.showError(
          'Error',
          "Vous n'avez pas les droits nécessaires"
        );
        oauthService.logOut();
      } else if (err.status !== 0) {
        // other errors
      }

      const error = JSON.stringify(err);
      let erreur = err.error?.error ? err.error.error : err.error;

      if (erreur instanceof Blob) {
        const reader = new FileReader();
        reader.onload = () => {
          erreur = reader.result;
        };
        reader.readAsText(erreur);
      } else {
        if (err.status === 504) {
          toastService.showError(translateService.instant('Timeout Error'), '');
        } else if (environment.production && err.status === 500) {
          toastService.showError(translateService.instant('Internal Error'), '');
        } else if (environment.production && err.status === 400) {
          toastService.showError(translateService.instant('Error'), erreur);
        } else if (environment.production && err.status === 408) {
          toastService.showError(
            translateService.instant('Error'),
            translateService.instant('Error.Timeout.408')
          );
        } else if (environment.production && ![0, 401].includes(err.status)) {
          toastService.showError(translateService.instant('Error'), '');
        } else if (!environment.production) {
          toastService.showError('Erreur', error);
        }
      }

      return throwError(() => error);
    })
  );
};
